import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

import AppStoreBadges from '../../components/AppStoreBadges';
import FooterSocialLinks from '../../components/FooterSocialLinks';
import { footerColumnTitleSx } from '../../components/footerSectionStyles';
import FooterBg from '../../assets/footer-bg.png';
import FooterImage from '../../assets/Group76.png';
import {
  FOOTER_PRODUCT_LINKS,
  KNOW_US_LINKS,
} from '../config/footerLinks';
import { isNative } from '../platform/capacitor';
import { useV2Common } from '../state/CommonProvider';

const contentContStyle = {
  fontFamily: 'Roboto',
  fontWeight: 'bold',
  display: 'flex',
  position: 'relative',
};

export default function V2Footer() {
  const navigate = useNavigate();
  const { isDesktop } = useV2Common();

  if (isNative()) return null;

  const linkSx = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    cursor: 'pointer',
    fontSize: isDesktop ? '15px' : '11px',
    fontWeight: 400,
    fontFamily: 'Roboto',
    '&:hover': { opacity: 0.85 },
  };

  const productsInset = isDesktop ? '6vw' : '4vw';
  const knowUsInset = isDesktop ? '4vw' : productsInset;
  const columnBlockSx = { mt: { xs: 3, md: 4 } };

  return (
    <Box
      component="footer"
      sx={{
        color: '#000',
        display: 'flex',
        p: '2vw',
        textAlign: 'center',
        flexDirection: 'column',
        background: `url(${FooterBg})`,
        backgroundSize: 'cover',
        pt: { xs: 2, md: '80px' },
        px: '2vw',
        pb: isDesktop
          ? 0
          : 'calc(72px + env(safe-area-inset-bottom, 0px))',
        minHeight: 'auto',
        width: '100%',
        boxSizing: 'border-box',
        mt: 0,
        mb: 0,
      }}
    >
      <Grid
        container
        rowSpacing={2}
        columnSpacing={2}
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          maxWidth: 1280,
          mx: 'auto',
          pb: 0,
          mb: 0,
        }}
      >
        <Grid xs={12} sm={6} md={6} lg={6}>
          <div style={contentContStyle}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ ...footerColumnTitleSx, marginLeft: productsInset }}>Our Products</Box>
              <Box sx={{ marginLeft: productsInset }}>
                {FOOTER_PRODUCT_LINKS.map((item) => (
                  <Box
                    key={item.path}
                    sx={linkSx}
                    onClick={() => navigate(item.path)}
                    role="link"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </Box>
                ))}
              </Box>
              <Box sx={{ ...columnBlockSx, marginLeft: productsInset }}>
                <Box sx={footerColumnTitleSx}>Download Our App</Box>
                <AppStoreBadges sx={{ justifyContent: 'flex-start' }} />
              </Box>
            </Box>
          </div>
        </Grid>

        <Grid xs={12} sm={6} md={6} lg={6}>
          <div style={contentContStyle}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ ...footerColumnTitleSx, marginLeft: knowUsInset }}>Know Us</Box>
              <Box sx={{ marginLeft: knowUsInset }}>
                {KNOW_US_LINKS.map((item) => (
                  <Box
                    key={item.path}
                    sx={linkSx}
                    onClick={() => navigate(item.path)}
                    role="link"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </Box>
                ))}
              </Box>
              <Box sx={{ ...columnBlockSx, marginLeft: knowUsInset }}>
                <FooterSocialLinks />
              </Box>
            </Box>
          </div>
        </Grid>

        <Grid sx={{ width: '100%', pb: 0, mb: 0 }}>
          <Box
            component="img"
            src={FooterImage}
            alt=""
            sx={{
              display: 'block',
              mx: 'auto',
              mt: { xs: 1, md: 2 },
              mb: 0,
              width: { xs: '80%', sm: '50%', md: '30%' },
              maxWidth: 420,
              height: 'auto',
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
